import styled from "styled-components";
import { useContext } from "react";
import { colors } from "../ui-elements/Main/MainTheme";
import { Text } from "../ui-elements/Main/Text";
import { useViewport } from '@/lib/layout/dimensions';
import { NavigationPaneRouteParamsContext } from '@/lib/navigation';
import { AccountInfoContext } from '@/components/subcomponents/account/account-info';
import { HelperAgentAvatar } from './HelperAgentAvatar';

export const HelperAgent = () => {
  const isMobile = useViewport((width) => width < 600, 500);
  const { subdomain } = useContext(AccountInfoContext);
  const navigate = (path) => {
    window.location.assign(path);
  };

  return (
    <>
      <Wrap
        id="helper-agent"
        onClick={() => navigate(`/accounts/${subdomain}/helper_agent`)}
      >
        <HelperAgentAvatar />
      </Wrap>
    </>
  )
}

const Wrap = styled.div`
  position: relative;
  cursor: pointer;
  margin-right: 10px;
  background-color: #FBF8F3;
  svg {
    position: relative;
    top: -1px;
    stroke: #0F493A;
  }
  padding: 5px;
  height: 36px;
  width: 36px;
  border: 1px solid rgba(224, 198, 183, 0.2);
  border-radius: 50%;
  z-index: 3;
  &:hover {
    background: ${colors.sand50};
  }
`;

const Tooltip = styled(Text)`
  background: black;
  padding: 12px 20px;
  border-radius: 12px;
  position: absolute;
  z-index: 1;
  white-space: nowrap;
  min-width: fit-content;
  right: 50%;
`
